<h1 mat-dialog-title>
  {{ 'properties.dialog.docDeleteTitle' | translate }} {{ barCode }}
</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <!-- The by-barcode lookup is the only source of the document _id accepted by delete-docs:
       when it comes back empty there is nothing to select, so the table and the confirmation
       question would be a dead end. -->
  <div class="mt-1 mb-3 ml-3" *ngIf="!dialogIsLoading && !docs.length">
    {{ 'properties.dialog.docDeleteEmpty' | translate }}
  </div>

  <table class="table table-borderless table-striped" *ngIf="docs.length">
    <thead>
      <th></th>
      <th>{{ 'properties.documentsPage.docType' | translate }}</th>
      <th>{{ 'properties.structures.structure' | translate }}</th>
    </thead>
    <tbody>
      <tr *ngFor="let doc of docs">
        <td>
          <mat-checkbox [checked]="doc.checked"
            (change)="onDocSelected(doc, $event.checked)" class="checkbox-insert">
          </mat-checkbox>
        </td>
        <td>
          {{ doc.docTitle }}
        </td>
        <td>
          {{ doc.area }} {{ doc.subArea }} {{ doc.structureObjectName }}
        </td>
      </tr>
    </tbody>
  </table>

  <div class="mt-1 mb-3 ml-3" *ngIf="docs.length">
    {{ 'properties.dialog.docDelete' | translate }}
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->
<div class="col-12 pb-4" mat-dialog-actions>
  <div class="col-6 text-left">
    <div class=" w-100">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div>
  </div>
  <div class="col-6 text-right" *ngIf="selectedDocs.length">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div>
</div>